import React from 'react'
import { Breadcrumb } from '@softura/fluentuipackage'
import './Breadcrumb.scss'

interface IProps {
  items?: any,
  maxDisplayedItems?: any,
  className?: any
}

const BreadcrumContainer = ({ items, maxDisplayedItems = 5, className = '' }:IProps) => {
  return (
    <Breadcrumb
     className = {`breadcrumb ${className}`}
     items = {items}
     maxDisplayedItems = {maxDisplayedItems}
     data-attribute="Breadcrumb_Default_Breadcrumb" />
  )
}

export default BreadcrumContainer
